import React from 'react';
import { Select } from 'antd';
import { SelectProps } from 'antd/lib/select';
import useSettings from 'hooks/useSettings';
import { EnumFields } from 'types/enumerationData';
import { Meta } from 'types/common';
import { sortByProperty } from 'utils/form';

type IProps = {
    value?: string;
    onChange?: (val: string) => void;
    disableValues?: string[];
    mode?: 'multiple' | '';
    // 字典之外需要补充的选项（如 credentialing 的 Urgent Care / Others），与字典项一起按字母排序，
    // 「Other(s)」这类兜底项固定排在最后
    extraOptions?: Meta[];
} & SelectProps;

const normLabel = (o: Meta) =>
    String(o.label ?? '')
        .trim()
        .toLowerCase();
const isOtherOption = (o: Meta) => ['other', 'others'].includes(normLabel(o));

const SpecialtyTypeSelect = (props: IProps) => {
    const { onChange, disableValues, mode, extraOptions, ...reset } = props;
    const [setting, loading] = useSettings();
    const specialtyOption = React.useMemo(() => {
        const dict = setting[EnumFields.HELLO_KLARITY_SPECIALTY] || [];
        // 补充项按 label 去重：后端字典后续补齐同名专科时不会出现重复选项（选项 key 也是 label）
        const dictLabels = new Set(dict.map((o) => normLabel(o)));
        const extra = (extraOptions || []).filter((o) => !dictLabels.has(normLabel(o)));
        // 注意用新数组：sortByProperty 是原地排序，直接传 setting 的数组会改到 store
        const all = sortByProperty([...dict, ...extra], 'label') as Meta[];
        return [...all.filter((o) => !isOtherOption(o)), ...all.filter(isOtherOption)];
    }, [setting, extraOptions]);
    return (
        <Select {...reset} onChange={onChange} loading={loading} showSearch virtual={false} mode={mode}>
            {specialtyOption.map((option: Meta) => {
                return (
                    <Select.Option
                        disabled={!!(disableValues?.includes(option.value as string) && reset.value !== option.value)}
                        key={option.label}
                        value={option.value}
                    >
                        {option.label}
                    </Select.Option>
                );
            })}
        </Select>
    );
};

export default SpecialtyTypeSelect;
